/** Formato persistido na API / inferência para registros sem coluna ou migrados. */

export type EvolutionEntryFormat = 'soap' | 'free_text';

export function resolveEvolutionEntryFormat(evo: {
  evolution_entry_format?: string | null;
  evolution_free_text?: string | null;
  subjective?: string | null;
  objective?: string | null;
  assessment?: string | null;
  plan?: string | null;
}): EvolutionEntryFormat {
  const f = evo?.evolution_entry_format;
  if (f === 'soap') return 'soap';
  if (f === 'free_text') return 'free_text';
  const soapAny = !!(evo?.subjective || evo?.objective || evo?.assessment || evo?.plan);
  const freeAny = !!(evo?.evolution_free_text && String(evo.evolution_free_text).trim());
  if (soapAny && !freeAny) return 'soap';
  return 'free_text';
}
